import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { accountSettingQueryOptions } from "app/pages/sales-intelligence/query/options";
import type { AccountSettingKey } from "app/pages/sales-intelligence/services/api/account-settings/types";

export const useAccountSettingQuery = (key: AccountSettingKey): UseQueryResult<string | null> => {
    return useQuery(accountSettingQueryOptions(key));
};
